module.exports = __webpack_public_path__ + "img/TicktingSystem.cb7c94ba.jpg";